import { useState } from "react";
import { Form, Input, Select, Button } from "antd";
import { ToastService } from "@shared/lib/services";
import { LEDGER_TYPE } from "@shared/lib/types/briefLedger";
import { useGetBriefLedgerFacets } from "@entities/brief/lib/hooks/useGetBriefLedgerFacets";
import { InputNumber } from "@shared/ui/InputNumber";
const { Option } = Select;

interface CreateBriefLedgerEntryProps {
  onSubmit: (values: any) => void;
  isSubmitting: boolean;
  onCancel: () => void;
}

export function CreateBriefLedgerEntry({
  onSubmit,
  isSubmitting,
  onCancel,
}: CreateBriefLedgerEntryProps) {
  const [form] = Form.useForm();

  const handleSubmit = (values: any) => {
    onSubmit(values);
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={handleSubmit}
      initialValues={{
        gstRate: 18,
        subType: "Others",
      }}
      onFinishFailed={({ errorFields }) => {
        if (errorFields.length) {
          ToastService.error(
            "Error Submitting Form. Please fill all required fields."
          );
        }
      }}
    >
      <Form.Item
        name="type"
        label="Type"
        rules={[{ required: true, message: "Type is required" }]}
      >
        <Select placeholder="Select Type">
          {Object.values(LEDGER_TYPE).map((type) => (
            <Option key={type} value={type}>
              {type}
            </Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item
        name="subType"
        label="Sub Type"
        rules={[{ required: true, message: "Sub Type is required" }]}
      >
        <Input disabled />
      </Form.Item>

      <Form.Item
        name="sellingCost"
        label="Selling Cost"
        rules={[{ required: true, message: "Selling Cost is required" }]}
      >
        <InputNumber
          type="number"
          style={{ width: "100%" }}
          placeholder="Enter Selling Cost"
          min={0}
        />
      </Form.Item>

      <Form.Item
        name="serviceCost"
        label="Service Cost"
        rules={[{ required: true, message: "Service Cost is required" }]}
      >
        <InputNumber
          style={{ width: "100%" }}
          type="number"
          placeholder="Enter Service Cost"
          min={0}
        />
      </Form.Item>

      <Form.Item
        name="gstRate"
        label="GST Rate (%)"
        rules={[{ required: true, message: "GST Rate is required" }]}
      >
        <InputNumber
          type="number"
          style={{ width: "100%" }}
          placeholder="Enter GST Rate "
          min={0}
          max={100}
        />
      </Form.Item>

      <Form.Item
        name="remarks"
        label="Remarks"
        rules={[{ required: true, message: "Remarks is required" }]}
      >
        <Input.TextArea
          placeholder="Enter Remarks"
          autoSize={{ minRows: 2, maxRows: 6 }}
        />
      </Form.Item>

      <Form.Item>
        <div
          style={{ display: "flex", gap: "8px", justifyContent: "flex-end" }}
        >
          <Button onClick={onCancel}>Cancel</Button>
          <Button
            type="primary"
            htmlType="submit"
            disabled={isSubmitting}
            loading={isSubmitting}
          >
            {isSubmitting ? "Creating..." : "Create"}
          </Button>
        </div>
      </Form.Item>
    </Form>
  );
}
